import React from 'react';

import HighlightedText from '@marketing/components/highlighted_text';

import WallOfLoveSection from '../../../sections/wall_of_love';

import JackHeadshot from './assets/jack_headshot.png';

export default (props) => {
  return (
    <WallOfLoveSection
      featuredQuote={{
        studentName: 'Jack S.',
        studentAffiliation: null,
        content: (
          <>
            "Magoosh really had everything that I needed to do well on the test.  It was a <HighlightedText color="#FCF0BF">one-stop shop</HighlightedText> for me; it was great.  When it came to the actual time to take the GMAT, I was confident in my ability to perform well because Magoosh allowed me to train so rigorously for it."
          </>
        ),
        image: {
          height: '329px',
          src: JackHeadshot,
          width: '409px'
        },
        video: {
          sources: [
            {
              src: 'https://d296n67kxwq0ge.cloudfront.net/audio_video/afde26e600d3ef729a9f3632be42cf0b459ae36b-video-23100/web.mp4',
              type: 'video/mp4'
            },
            {
              src: 'https://d296n67kxwq0ge.cloudfront.net/audio_video/afde26e600d3ef729a9f3632be42cf0b459ae36b-video-23100/web_webm.webm',
              type: 'video/webm'
            }
          ]
        }
      }}
      quotes={[
        {
          studentName: 'Cathal M.',
          studentAffiliation: null,
          content: (
            <>
              "Comes with a <HighlightedText color="#FCF0BF">mobile application</HighlightedText> that allows a user to browse videos while offline and a vast number of GMAT-like questions that provide <HighlightedText color="#FCF0BF">rich metrics</HighlightedText> the more you take them."
            </>
          )
        },
        {
          studentName: 'Vivek D.',
          studentAffiliation: null,
          content: (
            <>
              "I especially like the day-wise <HighlightedText color="#FCF0BF">study schedule</HighlightedText> in place—keeps me going on days when I think, 'What do I even do today?'"
            </>
          )
        },
        {
          studentName: 'Neha S.',
          studentAffiliation: null,
          content: (
            <>
              "I was someone who was getting back to studies after 9 years of gap. I found Magoosh to be <HighlightedText color="#FCF0BF">most economical</HighlightedText>. Magoosh's contribution has been invaluable in building my basics."
            </>
          )
        },
        {
          studentName: 'Lucila Q.',
          studentAffiliation: null,
          content: (
            <>
              "Has <HighlightedText color="#FCF0BF">AI</HighlightedText> to clarify specific doubts on theory related to the exercises!

"
            </>
          )
        }
      ]}
    />
  );
};
